import React from "react";
import Module from "./Popup";

function Completed({
    redirect,
    totalBatch,
    completedBatch,
    enableCounterScreen,
    completedTest,
}) {
    const handleClickContinue = () => {
        if (completedTest || totalBatch == completedBatch) {
            window.location.replace(redirect);
        } else {
            enableCounterScreen();
        }
    };
    if (completedTest) {
        completedBatch = totalBatch;
    }
    return (
        <Module.PopupBreatherFM
            toggle={handleClickContinue}
            totalStage={totalBatch}
            completedStage={completedBatch}
        />
    );
}

export default Completed;
